import { render, staticRenderFns } from "./OtherOverheadsTabs.vue?vue&type=template&id=48150b9d&scoped=true"
import script from "./OtherOverheadsTabs.vue?vue&type=script&lang=js"
export * from "./OtherOverheadsTabs.vue?vue&type=script&lang=js"
import style0 from "./OtherOverheadsTabs.vue?vue&type=style&index=0&id=48150b9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48150b9d",
  null
  
)

export default component.exports